var _excluded = ["items"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import FlexBox from '../flexbox/FlexBox';
import { ScheduleItem } from './';
import { jsx as ___EmotionJSX } from "@emotion/react";
var ScheduleList = function ScheduleList(_ref) {
  var items = _ref.items,
    rest = _objectWithoutProperties(_ref, _excluded);
  var list = items.map(function (item, i) {
    return ___EmotionJSX(ScheduleItem, {
      time: item.time,
      text: item.text,
      backgroundColor: i % 2 ? '#f5f6f7' : '',
      key: i
    });
  });
  return ___EmotionJSX(FlexBox, _extends({
    directionColumn: true
  }, rest), list);
};
export default ScheduleList;